const SEK = 'SEK';
const EUR = 'EUR';
const USD = 'USD';

const currencies = [
  SEK,
  EUR,
  USD,
];

const currencyLocale = {
  SEK: 'sv-SE',
  EUR: 'en-GB',
  USD: 'en-US',
};

module.exports = {
  SEK,
  EUR,
  USD,
  currencies,
  currencyLocale,
};
